// Auto-generated by generateInfinityCardImageMap.js

import archers_charm from "../assets/infinityCards/archers_charm.png";
import aura_renewal from "../assets/infinityCards/aura_renewal.png";
import barkskin_brew from "../assets/infinityCards/barkskin_brew.png";
import berserkers_elixir from "../assets/infinityCards/berserkers_elixir.png";
import blazing_fang_blade from "../assets/infinityCards/blazing_fang_blade.png";
import boneblade_fragment from "../assets/infinityCards/boneblade_fragment.png";
import boneknuckle_ring from "../assets/infinityCards/boneknuckle_ring.png";
import crimson_edge_shard from "../assets/infinityCards/crimson_edge_shard.png";
import crystal_armor_shard from "../assets/infinityCards/crystal_armor_shard.png";
import divine_drop from "../assets/infinityCards/divine_drop.png";
import eagle_eye_elixir from "../assets/infinityCards/eagle_eye_elixir.png";
import elixer_of_vital_spark from "../assets/infinityCards/elixer_of_vital_spark.png";
import emberfang_blade from "../assets/infinityCards/emberfang_blade.png";
import emberhide_inlay from "../assets/infinityCards/emberhide_inlay.png";
import enhanced_vitality_vial from "../assets/infinityCards/enhanced_vitality_vial.png";
import ethersteel_wraps from "../assets/infinityCards/ethersteel_wraps.png";
import falcons_feather_band from "../assets/infinityCards/falcons_feather_band.png";
import feral_claw_gauntlets from "../assets/infinityCards/feral_claw_gauntlets.png";
import flamebrand_dagger from "../assets/infinityCards/flamebrand_dagger.png";
import fortified_obsidian_core from "../assets/infinityCards/fortified_obsidian_core.png";
import fortify_elixir from "../assets/infinityCards/fortify_elixir.png";
import frostglint_liquid from "../assets/infinityCards/frostglint_liquid.png";
import ghoststeel_shuriken from "../assets/infinityCards/ghoststeel_shuriken.png";
import ghoststeel_spike from "../assets/infinityCards/ghoststeel_spike.png";
import glimmerdust_vial from "../assets/infinityCards/glimmerdust_vial.png";
import greater_healing_potion from "../assets/infinityCards/greater_healing_potion.png";
import guardians_draught from "../assets/infinityCards/guardians_draught.png";
import healing_brew from "../assets/infinityCards/healing_brew.png";
import herbal_tonic from "../assets/infinityCards/herbal_tonic.png";
import ironclaw_gloves from "../assets/infinityCards/ironclaw_gloves.png";
import ironhide_gauntlets from "../assets/infinityCards/ironhide_gauntlets.png";
import lifebloom_potion from "../assets/infinityCards/lifebloom_potion.png";
import luminous_liquid from "../assets/infinityCards/luminous_liquid.png";
import majestic_lifebloom_potion from "../assets/infinityCards/majestic_lifebloom_potion.png";
import minor_healing_potion from "../assets/infinityCards/minor_healing_potion.png";
import moonlight_scope from "../assets/infinityCards/moonlight_scope.png";
import mystic_eyestone from "../assets/infinityCards/mystic_eyestone.png";
import mystic_mender from "../assets/infinityCards/mystic_mender.png";
import net_of_binding from "../assets/infinityCards/net_of_binding.png";
import obsidian_bracers from "../assets/infinityCards/obsidian_bracers.png";
import paralysis_powder from "../assets/infinityCards/paralysis_powder.png";
import phantom_plate_fragment from "../assets/infinityCards/phantom_plate_fragment.png";
import pitfall_token from "../assets/infinityCards/pitfall_token.png";
import potion from "../assets/infinityCards/potion.png";
import pulse_of_life from "../assets/infinityCards/pulse_of_life.png";
import razorleaf_shard from "../assets/infinityCards/razorleaf_shard.png";
import refined_rejuvenation_elixir from "../assets/infinityCards/refined_rejuvenation_elixir.png";
import rejuvenation_elixir from "../assets/infinityCards/rejuvenation_elixir.png";
import renewal_nectar from "../assets/infinityCards/renewal_nectar.png";
import savage_brew from "../assets/infinityCards/savage_brew.png";
import scope_of_the_silver_eye from "../assets/infinityCards/scope_of_the_silver_eye.png";
import seers_lens from "../assets/infinityCards/seers_lens.png";
import serenity_serum from "../assets/infinityCards/serenity_serum.png";
import sharpened_lens_tonic from "../assets/infinityCards/sharpened_lens_tonic.png";
import shell_oil from "../assets/infinityCards/shell_oil.png";
import shock_mine from "../assets/infinityCards/shock_mine.png";
import sightstone_fragment from "../assets/infinityCards/sightstone_fragment.png";
import sleep_mist from "../assets/infinityCards/sleep_mist.png";
import smoke_lens_powder from "../assets/infinityCards/smoke_lens_powder.png";
import snare_trap from "../assets/infinityCards/snare_trap.png";
import steadyhand_brew from "../assets/infinityCards/steadyhand_brew.png";
import stoneflesh_serum from "../assets/infinityCards/stoneflesh_serum.png";
import stoneheart_core from "../assets/infinityCards/stoneheart_core.png";
import superior_renewal_nectar from "../assets/infinityCards/superior_renewal_nectar.png";
import thunderroot_tonic from "../assets/infinityCards/thunderroot_tonic.png";
import tiny_elixir from "../assets/infinityCards/tiny_elixir.png";
import titanhide_layering from "../assets/infinityCards/titanhide_layering.png";
import titanroot_tonic from "../assets/infinityCards/titanroot_tonic.png";
import totem_of_the_ravager from "../assets/infinityCards/totem_of_the_ravager.png";
import trickshot_flask_supreme from "../assets/infinityCards/trickshot_flask_supreme.png";
import trickshot_tonic from "../assets/infinityCards/trickshot_tonic.png";
import venom_tipped_blade from "../assets/infinityCards/venom_tipped_blade.png";
import vitality_vial from "../assets/infinityCards/vitality_vial.png";
import warhorn_brew from "../assets/infinityCards/warhorn_brew.png";
import warriors_totem from "../assets/infinityCards/warriors_totem.png";
import whisperleaf_elixir_max from "../assets/infinityCards/whisperleaf_elixir_max.png";
import whisperleaf_extract from "../assets/infinityCards/whisperleaf_extract.png";

export const infinityCardImageMap = {
  archers_charm,
  aura_renewal,
  barkskin_brew,
  berserkers_elixir,
  blazing_fang_blade,
  boneblade_fragment,
  boneknuckle_ring,
  crimson_edge_shard,
  crystal_armor_shard,
  divine_drop,
  eagle_eye_elixir,
  elixer_of_vital_spark,
  emberfang_blade,
  emberhide_inlay,
  enhanced_vitality_vial,
  ethersteel_wraps,
  falcons_feather_band,
  feral_claw_gauntlets,
  flamebrand_dagger,
  fortified_obsidian_core,
  fortify_elixir,
  frostglint_liquid,
  ghoststeel_shuriken,
  ghoststeel_spike,
  glimmerdust_vial,
  greater_healing_potion,
  guardians_draught,
  healing_brew,
  herbal_tonic,
  ironclaw_gloves,
  ironhide_gauntlets,
  lifebloom_potion,
  luminous_liquid,
  majestic_lifebloom_potion,
  minor_healing_potion,
  moonlight_scope,
  mystic_eyestone,
  mystic_mender,
  net_of_binding,
  obsidian_bracers,
  paralysis_powder,
  phantom_plate_fragment,
  pitfall_token,
  potion,
  pulse_of_life,
  razorleaf_shard,
  refined_rejuvenation_elixir,
  rejuvenation_elixir,
  renewal_nectar,
  savage_brew,
  scope_of_the_silver_eye,
  seers_lens,
  serenity_serum,
  sharpened_lens_tonic,
  shell_oil,
  shock_mine,
  sightstone_fragment,
  sleep_mist,
  smoke_lens_powder,
  snare_trap,
  steadyhand_brew,
  stoneflesh_serum,
  stoneheart_core,
  superior_renewal_nectar,
  thunderroot_tonic,
  tiny_elixir,
  titanhide_layering,
  titanroot_tonic,
  totem_of_the_ravager,
  trickshot_flask_supreme,
  trickshot_tonic,
  venom_tipped_blade,
  vitality_vial,
  warhorn_brew,
  warriors_totem,
  whisperleaf_elixir_max,
  whisperleaf_extract,
};
